import { ConsignmentDetails } from 'types';
import { Collect, DashboardHistoryAndTracking, FabSupport } from 'components';
import { STATUSES } from 'commons';
import * as S from './styles';

interface Props {
  consignment: ConsignmentDetails;
}

export function StepDelivered({ consignment }: Props) {
  const { code: consignmentCode } = consignment;
  const isCancelled = consignment.status === STATUSES.CANCELLED.value;

  return (
    <S.Main>
      {!isCancelled && <Collect consignment={consignment} />}

      <DashboardHistoryAndTracking consignmentCode={consignmentCode} />

      <FabSupport consignmentCode={consignmentCode} />
    </S.Main>
  );
}
